import React, { useEffect, useState } from 'react';
import { useWindowSize } from '@uidotdev/usehooks';
import BreadcrumbItem from '../BreadcrumbItem';
import { STATIC_UPPSALA_SVG_URL } from '../../../lib/constants';
const Breadcrumbs = (props) => {
    const size = useWindowSize();
    const [linkItems, setLinkItems] = useState([]);
    const currentIndex = linkItems.findIndex((item) => item.isCurrent === true);
    const previousLinkItemIndex = currentIndex - 1;
    useEffect(() => {
        createBreadcrumbTrail();
    }, [window.location.pathname]);
    const createBreadcrumbTrail = () => {
        const currentUrl = window.location.pathname;
        const segments = currentUrl.split('/').filter((segment) => segment !== '');
        const breadcrumbTrail = segments.map((segment, index) => {
            const href = `/${segments.slice(0, index + 1).join('/')}`;
            const text = segment.charAt(0).toUpperCase() + segment.slice(1);
            return { text, href };
        });
        breadcrumbTrail.unshift({ text: 'Startsida', href: '/' });
        breadcrumbTrail[breadcrumbTrail.length - 1].isCurrent = true;
        setLinkItems(breadcrumbTrail);
        return breadcrumbTrail;
    };
    return (React.createElement("div", { id: "breadcrumbs", className: `mt-1 mb-5 ${props.className ?? ''}`, style: props.style },
        React.createElement("nav", { "aria-label": "Br\u00F6dsmulor" }, size.width && size.width < 992 ? (React.createElement("div", { className: "flex flex-row items-center" },
            React.createElement("img", { width: 18, height: 18, src: STATIC_UPPSALA_SVG_URL + 'left-arrow.svg', alt: "left-arrow" }),
            React.createElement("ul", { className: "m-0 p-0" }, linkItems.map((item) => {
                return (React.createElement(BreadcrumbItem, { key: `breadcrumb_item_link_${item.text}`, linkItem: { text: item.text, href: item.href, isCurrent: item.isCurrent }, onClick: props.onClick, ignoreSeparator: true }));
            })[previousLinkItemIndex]))) : (React.createElement("ul", { className: "flex flex-row items-center p-0" }, linkItems.map((item) => {
            return (React.createElement(BreadcrumbItem, { key: `breadcrumb_item_link_${item.text}`, linkItem: { text: item.text, href: item.href, isCurrent: item.isCurrent }, onClick: props.onClick }));
        }))))));
};
export default Breadcrumbs;
